import React from 'react';
import Routess from './routes';

export default function App() {
  return (
      <Routess />
  );
}